const Env = process.env.NODE_ENV
const BUILD = process.env.NODE_BUILD
const BASIC_URL = Env == 'development' ? '//api.uooc.online:8088' : `//${BUILD_TYPE}.uooconline.com`

let config = {
  env: Env,
  basicUrl: BASIC_URL,
  docUrl: `${BASIC_URL}/upload/index`,
  pagesize: 10,
  WEIXIN_APP_ID: 'wxf25196c167d555e6',
  UOOC_LOGO: '//assets.uooconline.com/upload/2018/03/28/uooc_logo.png'
};
export default config;



// WEBPACK FOOTER //
// ./src/store/config.js